import { User } from '@guiker/authentication-shared'

import { RentalListing } from '../rentalListing'

export const isListingOperator = (currentUser: User, listing: RentalListing) =>
  currentUser && listing.listingOperators?.map((uo) => uo.userId).includes(currentUser.id)
